import { ReactComponent as Icon } from "./logout.svg";

const LogoutIcon = () => {
    return <Icon />;
}

export default LogoutIcon;